/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Pain_Muscle_AcuteInputs */

const en_us2_workout_after_pain_muscle_acute = /** @type {(inputs: Workout_After_Pain_Muscle_AcuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sharp muscle pain`)
};

const pt_br2_workout_after_pain_muscle_acute = /** @type {(inputs: Workout_After_Pain_Muscle_AcuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dor muscular aguda`)
};

const es_419_workout_after_pain_muscle_acute = /** @type {(inputs: Workout_After_Pain_Muscle_AcuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolor muscular agudo`)
};

const pt_pt2_workout_after_pain_muscle_acute = /** @type {(inputs: Workout_After_Pain_Muscle_AcuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dor muscular aguda`)
};

const fr_fr2_workout_after_pain_muscle_acute = /** @type {(inputs: Workout_After_Pain_Muscle_AcuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Douleur musculaire vive`)
};

const de_de2_workout_after_pain_muscle_acute = /** @type {(inputs: Workout_After_Pain_Muscle_AcuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stechender Muskelschmerz`)
};

const it_it2_workout_after_pain_muscle_acute = /** @type {(inputs: Workout_After_Pain_Muscle_AcuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolore muscolare acuto`)
};

/**
* | output |
* | --- |
* | "Sharp muscle pain" |
*
* @param {Workout_After_Pain_Muscle_AcuteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_pain_muscle_acute = /** @type {((inputs?: Workout_After_Pain_Muscle_AcuteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Pain_Muscle_AcuteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_pain_muscle_acute(inputs)
	if (locale === "es-419") return es_419_workout_after_pain_muscle_acute(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_pain_muscle_acute(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_pain_muscle_acute(inputs)
	if (locale === "de-DE") return de_de2_workout_after_pain_muscle_acute(inputs)
	if (locale === "it-IT") return it_it2_workout_after_pain_muscle_acute(inputs)
	return en_us2_workout_after_pain_muscle_acute(inputs)
});
export { workout_after_pain_muscle_acute as "workout-after.pain_muscle_acute" }